import React from "react";
import PropTypes from "prop-types";

import moment from "moment";

import TripLegs from "./TripLegs";

import {
  useTripLegZeroDirections,
  useTripLastLegDirections,
  useTripLegDirections
} from "./hooks";

const getTotalTime = (firstLeg, lastLeg) => {
  if (
    Array.isArray(firstLeg) &&
    Array.isArray(lastLeg) &&
    firstLeg.length &&
    lastLeg.length
  ) {
    const { PickupDate: firstStartTime } = firstLeg[0];
    const {
      PickupDate: secondStartTime,
      Route: { TravelTime }
    } = lastLeg[0];
    if (firstStartTime && secondStartTime) {
      const t1 = moment(firstStartTime).valueOf();
      const t2 = moment(secondStartTime)
        .add(TravelTime, "hours")
        .valueOf();

      return ((t2 - t1) / (60 * 60 * 1000)).toFixed(2);
    }
  }
  return 0;
};
const TripItem = ({ label, legs: initialLegs }) => {
  const legs = initialLegs.sort((a, b) => {
    if (a.Leg > b.Leg) return 1;
    if (b.Leg > a.Leg) return -1;
    return 0;
  });

  const { linkedLegs, loading } = useTripLegDirections(legs);

  const firstLeg = linkedLegs.find(l => l.Leg === 1);
  const lastStop = Math.max(...legs.map(l => l.Leg));
  const lastLeg = linkedLegs.find(l => l.Leg === lastStop);

  const { legZero } = useTripLegZeroDirections(firstLeg);
  const { leg } = useTripLastLegDirections(lastLeg, legs.length);

  const totalHours = getTotalTime(legZero, leg);

  return (
    <div className="trip-item">
      <div className="trip-item-body">
        <div className="trip-item-body-item">
          <TripLegs
            label={label}
            linkedLegs={[
              ...legZero,
              ...linkedLegs,
              ...(label !== "Untripped" ? leg : [])
            ]}
            loading={loading}
          />
        </div>
        {firstLeg && lastLeg && (
          <div className="trip-item-trip-total">
            <p>
              <span>Total Hours:&nbsp;</span>
              <span className={totalHours > 13 ? "is-danger" : "is-success"}>
                {totalHours} hrs
              </span>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
TripItem.propTypes = {
  legs: PropTypes.array,
  label: PropTypes.string
};

export default TripItem;
